import { render, staticRenderFns } from "./EvaluateTestscreen.vue?vue&type=template&id=813a4c76"
import script from "./EvaluateTestscreen.vue?vue&type=script&lang=js"
export * from "./EvaluateTestscreen.vue?vue&type=script&lang=js"
import style0 from "./EvaluateTestscreen.vue?vue&type=style&index=0&id=813a4c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports